<div fxLayout="column">
    <mat-chip-listbox *ngIf="chipsPosition === 'top'">
        <mat-chip *ngFor="let object of value" (removed)="removeObject(object)" disableRipple="true" [disabled]="disabled">
            <ng-template [ngTemplateOutlet]="chipTemplate" [ngTemplateOutletContext]="{ content: object }"></ng-template>
            <mat-icon *ngIf="!disabled" matChipRemove svgIcon="cancel"></mat-icon>
        </mat-chip>
    </mat-chip-listbox>
    <syn-picker
        #picker
        [formControl]="objectPickerControl"
        [placeholder]="required !== undefined ? placeholder + ' *' : placeholder"
        [contentLoader]="contentLoader"
        [content]="content"
        [itemTemplate]="itemTemplate"
        [newItemTemplate]="newItemTemplate"
        [strictSearch]="strictSearch"
        [errorMessage]="errorMessage"
        [translations]="translations"
        [disabledPick]="disabled"
        (creationEvent)="onCreateObject($event)">
    </syn-picker>

    <mat-chip-listbox *ngIf="chipsPosition === 'bottom'">
        <mat-chip disableRipple disableRipple *ngFor="let object of value" (removed)="removeObject(object)" disableRipple="true" [disabled]="disabled">
            <ng-template [ngTemplateOutlet]="chipTemplate" [ngTemplateOutletContext]="{ content: object }"></ng-template>
            <mat-icon *ngIf="!disabled" matChipRemove svgIcon="cancel"></mat-icon>
        </mat-chip>
    </mat-chip-listbox>
</div>
